import axios from "axios"
import { getUrl, getErrorMessage, headers } from "../networkconfig"
import { DemoFormType } from "../../pages/form/demoFormPage"

const scheduleDemo = async (userData: DemoFormType) => {
  const endpoint = `scheduleDemo`
  const url = getUrl(endpoint)

  try {
    const { data } = await axios.post(url, {...userData}, {
      headers: {
        ...headers
      }
    })

    if (!data.status) return { error: "Request error" }

    return parseResponse(data)
  } catch (error) {
    return getErrorMessage(error)
  }
}

const parseResponse = (response: any) => {
  return response
}

export default scheduleDemo